import { Component, OnInit, Output, EventEmitter, Input, ViewChild, OnChanges } from '@angular/core';
import { RequestsEvaluated } from './shared/requests-evaluated.model';
import { MatTableDataSource, MatDialogConfig, MatDialog, MatPaginator, MatSort } from '@angular/material';
import { ConfirmationDialogComponent } from 'src/app/core/modal/confirmation-dialog/confirmation-dialog.component';
import { ReturnRecognition } from './shared/returnRecognition.model';
import { ReportsService } from './shared/reports.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit, OnChanges {
  displayedColumns: string[] = ['facultad', 'fechaEvaluacion', 'cedula', 'codMateriaSolic',
                                'codMateriaRecon', 'semestre', 'nota', 'tipoSolicitud', 'operaciones'];

  dataSource: MatTableDataSource<RequestsEvaluated>;
  messageError: String = '';
  claseMessage: String = 'messaje-error';
  @Output()
  sendSearchRequest: EventEmitter<any> = new EventEmitter();
  @Input() requets: RequestsEvaluated[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private dialog: MatDialog,
              private reporstService: ReportsService) {
     this.setTable();
  }

  ngOnInit() {
     this.setTable();
  }

  ngOnChanges() {
     this.setTable();
  }

  deshacer(row: RequestsEvaluated) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'Mensaje Confirmación', message:
    '¿Esta seguro que desea deshacer el reconocimiento de materia seleccionada?'};
    dialogConfig.width = '30%';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value === 1) {
          const returnR = new ReturnRecognition();
          returnR.solicitud = row.solicitud;
          returnR.consecutivo = row.consecutivo;
          returnR.materia = row.codMateriaRecon;
          this.reporstService.returnRecognition(returnR).subscribe(
            (result) => {
              if (result.data) {
                if (result.data === 'OK') {
                  const index = this.requets.indexOf(row);
                  if (index > -1) {
                    this.requets.splice(index, 1);
                    this.setTable();
                 }
                  this.claseMessage = 'messaje-success';
                  this.messageError = 'Se deshizo el reconocimiento #' + row.solicitud;
                } else {
                  this.claseMessage = 'messaje-error';
                  this.messageError = result.data;
                }
              }
            }
          );
        }
    });

  }

  private setTable() {
    this.dataSource = new MatTableDataSource(this.requets);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

  }

}
